import React, { useState, useEffect } from "react";
import { func, string } from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";

const RedirectNoPermission = ({
  dispatch,
  permissionText = "access this feature",
}) => {
  const [redirecting, setRedirecting] = useState(false);
  const [redirectTimer, setRedirectTimer] = useState(5);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    setRedirecting(true);
  }, []);

  useEffect(() => {
    if (!redirecting) {
      return;
    }

    const id = setInterval(() => {
      setRedirectTimer((prevTimer) => {
        if (prevTimer === 1) {
          clearInterval(id);
          dispatch(push("/"));
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    setIntervalId(id);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [redirecting]);

  return (
    <div style={{ margin: "15px" }}>
      {`You don't have permission to ${permissionText}. If you have any questions about permissions, please contact your administrator. `}
      <b>You will be redirected to the dashboard in {redirectTimer} seconds</b>
    </div>
  );
};

RedirectNoPermission.propTypes = {
  dispatch: func.isRequired,
  permissionText: string,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(null, mapDispatchToProps)(RedirectNoPermission);
